import axios from 'axios';
import { metric } from '@fiverr-private/perseus';

export const getGigs = async({ url, type }) => {
    try {
        const { data } = await axios.get(url);
        const { gigs } = data;
        if (gigs.length) {
            return gigs;
        } else {
            throw new Error('Gigs carousel received and empty list');
        }
    } catch (error) {
        const status = error.response && error.response.status || 'unknown';
        metric.count(`bad_response.carousels.${status}.${type}`);
        throw error;
    }
};
